import { GUEST_REGISTER, GUEST_REGISTER_ERROR, GUEST_REGISTER_HIDE_ERROR, GUEST_REGISTER_START_LOADER, GUEST_REGISTER_STOP_LOADER, } from "../interface/iGuestRegister";
const initState = {
    data: {
        message: "",
        registeredDate: "",
        uniqueID: "",
        OTPValidated: false,
        isClient: false,
        isGuest: false,
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const guestRegister = (state = initState, action) => {
    switch (action.type) {
        case GUEST_REGISTER: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case GUEST_REGISTER_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case GUEST_REGISTER_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case GUEST_REGISTER_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case GUEST_REGISTER_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default guestRegister;
